import antdData from 'antd/lib/locale-provider/fr_FR'
import localeData from 'react-intl/locale-data/fr'

const messages = {
  'topBar.typeToSearch': 'Chercher...',
  'topBar.profileMenu.hello': 'Bonjour',
  'topBar.profileMenu.role': 'Rôle',
  'topBar.profileMenu.email': 'Email',
  'topBar.profileMenu.phone': 'Téléphone',
  'topBar.profileMenu.manageMembership': "Gérer l'adhésion",
  'topBar.profileMenu.editProfile': 'Editer le profil',
  'topBar.profileMenu.changePassword': 'Changer le mot de passe',
  'topBar.profileMenu.logout': 'Connectez - Out',
  'member.profile.emailAddressTitle': 'Adresse électronique',
  'member.profile.emailAddress': "Entrer l'adresse e-mail",
  'member.profile.validEmail': "L'entrée n'est pas valide E-mail!",
  'member.profile.enterEmail': "S'il vous plaît entrer Email!",
  'member.profile.saveButton': 'Sauvegarder',
  'member.profile.changePasswordTitle': 'Changer le mot de passe',
  'member.profile.password': 'Mot de passe',
  'member.profile.confirmPassword': 'Confirmez le mot de passe',
  'member.profile.inputPassword': 'Veuillez saisir votre mot de passe!',
  'member.profile.inputConfirmPassword': 'Veuillez confirmer votre mot de passe!',
  'member.profile.buttonUpdatePassword': 'Mettre à jour le mot de passe',
}

export default {
  locale: 'fr-FR',
  antdData,
  localeData,
  messages,
}
